import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import IPracticeState from "./models/IPracticeState";
import PracticeModel from "./models/PracticeModel";
import PracticeAction from "./PracticeAction";

export default class PracticeReducer extends BaseReducer<IPracticeState> {
    public readonly initialState: IPracticeState = {
        practice: new PracticeModel({}),
        openAvvisoPopup: false,
    };

    public [PracticeAction.REQUEST_PRACTICE_FINISHED](
        state: IPracticeState,
        action: IAction<PracticeModel>
    ): IPracticeState {
        const errors = action?.payload?.errors;
        const warnings = action?.payload?.warnings;
        //const practiceId = action?.payload?.idPractice;
        const hasErrorsOrWarnings = (errors && errors.length > 0) || (warnings && warnings.length > 0);
        return {
            ...state,
            practice: action.payload!,
            openAvvisoPopup: hasErrorsOrWarnings || false,
        };
    }

    public [PracticeAction.PRACTICE_SET_AVVISO_POPUP](state: IPracticeState, action: IAction<boolean>): IPracticeState {
        return {
            ...state,
            openAvvisoPopup: action.payload!,
        };
    }
}
